import JobsTable from './JobsTableContainer';

export default JobsTable;
